// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iDcN","questions":"styles_questions__3-WlJ","footer":"styles_footer__IxdSI"};